import { type ReactNode } from 'react';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationServerContext } from '../../state';
import { Desktop } from './Desktop';
import { Mobile } from './Mobile';
import { ServerError } from './ServerError';

export function Layout(props: { children?: ReactNode }) {
  const { isMobile } = useScreenSize();
  const [serverState] = useApplicationServerContext();
  const isServerError = 'error' in serverState;

  return (
    <>
      {isServerError && <ServerError>{props.children}</ServerError>}
      {!isServerError && isMobile !== undefined && isMobile === true && (
        <Mobile>{props.children}</Mobile>
      )}
      {!isServerError && isMobile !== undefined && isMobile === false && (
        <Desktop>{props.children}</Desktop>
      )}
    </>
  );
}
